import HistoricalMetricsRedesign from './HistoricalMetricsRedesign';

export default HistoricalMetricsRedesign;
